import React from 'react';
import styled from 'styled-components';
import { createTimeInstance } from '@utils/time';
import { Body5, Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import { Working } from '@ui/Working';
import InputField from '@containers/form/InputField';

// Maps the expiry dropdown to a day offset; `null` => never expires (omit
// expires_at). Computed to an ISO-8601 instant at submit time.
const EXPIRY_PRESETS = [
  { label: 'Never', days: null },
  { label: '30 days', days: 30 },
  { label: '60 days', days: 60 },
  { label: '90 days', days: 90 },
  { label: '1 year', days: 365 },
];

const SelectWrapper = styled.div`
  select {
    height: 40px;
    padding: 0 8px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.themeColors.text};
    border-radius: 5px;
    background: ${({ theme }) => theme.themeColors.inputBg};
    color: ${({ theme }) => theme.themeColors.text};
  }
`;
const ValidationWrap = styled.div`
  color: ${({ theme }) => theme.themeColors.error};
  font-size: 14px;
  line-height: 16px;
  min-height: 16px;
`;

export const CreateApiKeyForm = ({ isCreating, createError, onCreate, onNameChange }) => {
  const [name, setName] = React.useState('');
  const [presetIndex, setPresetIndex] = React.useState(0);

  const handleNameChange = (e) => {
    setName(e.target.value);
    onNameChange();
  };

  const handleSubmit = async () => {
    const days = EXPIRY_PRESETS[presetIndex].days;
    const expires_at = days === null ? null : createTimeInstance().add(days, 'day').toISOString();
    const ok = await onCreate({ name: name.trim(), expires_at });
    if (ok) {
      setName('');
      setPresetIndex(0);
    }
  };

  const isDisabled = !name.trim() || isCreating;

  return (
    <div>
      <Container bottom={8}>
        <Body5 bold>Name</Body5>
      </Container>
      <InputField
        id="api-key-name"
        placeholder="e.g. my integration"
        value={name}
        onChange={handleNameChange}
        margin="0"
      />

      <Container top={16} bottom={8}>
        <Body5 bold>Expiration</Body5>
      </Container>
      <SelectWrapper>
        <select value={presetIndex} onChange={(e) => setPresetIndex(Number(e.target.value))}>
          {EXPIRY_PRESETS.map((preset, i) => (
            <option key={preset.label} value={i}>
              {preset.label}
            </option>
          ))}
        </select>
      </SelectWrapper>

      <Container top={16}>
        <ValidationWrap>{createError || null}</ValidationWrap>
      </Container>

      <Container top={8}>
        <FlatButton id="create-api-key-submit" disabled={isDisabled} onClick={handleSubmit}>
          Create API key
        </FlatButton>
      </Container>

      {isCreating && (
        <Container top={16}>
          <Working message="Creating..." noVerticalPadding />
        </Container>
      )}
    </div>
  );
};
